export default __webpack_public_path__ + "static/media/captain.20d6b33c.png";